import React from 'react';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { TextField, type TextFieldProps } from '@mui/material';
import StripeInput from './StripeInput.web';

export const CardNumberField = (props: TextFieldProps): JSX.Element => (
  <TextField
    {...props}
    sx={{ "& .MuiInputBase-input": { fontSize: 14, height: '0.9650em', paddingTop: "14px" } }}
    label={null}
    InputLabelProps={{ shrink: true }}
    InputProps={{
      inputComponent: StripeInput,
      inputProps: {
        component: CardNumberElement,
        options: {
          showIcon: true,
        },
      },
    }}
  />
);

export const ExpirationDateField = (props: TextFieldProps): JSX.Element => (
  <TextField
    {...props}
    label={null}
    sx={{ "& .MuiInputBase-input": { fontSize: 14, height: '0.9650em', paddingTop: "14px" } }}
    InputLabelProps={{ shrink: true }}
    InputProps={{
      inputComponent: StripeInput,
      inputProps: {
        component: CardExpiryElement,
      },
    }}
  />
);

export const CVCField = (props: TextFieldProps): JSX.Element => (
  <TextField
    {...props}
    sx={{ "& .MuiInputBase-input": { fontSize: 14, height: '0.9650em', paddingTop: "14px" } }}
    label={null}
    InputLabelProps={{ shrink: true }}
    InputProps={{
      inputComponent: StripeInput,
      inputProps: {
        component: CardCvcElement,
      },
    }}
  />
);
